import * as yup from 'yup';
import {
    AnyObjectSchema,
    BooleanSchema,
    StringSchema
} from 'yup';
import regex from '@/helpers/regex';

type IValidate<R = BooleanSchema | StringSchema> = () => R;

const validation: IValidate<AnyObjectSchema> = () => yup.object().shape({
    name: yup
        .string()
        .matches(regex.name, 'Jsou zadány nepovolené znaky.')
        .required('Jméno je povinné.'),
    email: yup
        .string()
        .matches(regex.email, 'E-mail není zadán ve správném formátu.')
        .required('E-mail je povinný.'),
    message: yup
        .string()
        .matches(regex.text, 'Jsou zadány nepovolené znaky.')
        .required('Zpráva ja povinná.'),
    med: yup
        .string()
        .max(0),
});

export default validation;
